<template>
    <fieldset>
        <legend>Account information</legend>

        <!-- Why decoys? Prevent browser autocomplete. -->
        <label class="decoy">
            <span>Username</span><input type="text" name="decoy_username" id="decoy-username">
        </label>
        <label class="decoy">
            <span>Password</span><input type="password" name="password_decoy" id="decoy-password">
        </label>

        <label-input
            label="Username"
            name="username"
            :required="true"
            v-model="person.username.$model"
            :validator="person.username"
            :error-message="usernameMessage"
        />

        <label-input
            v-if="newPerson"
            type="password"
            label="Password"
            name="password"
            :required="!userIsAdmin"
            v-model="person.password.$model"
            :validator="person.password"
            error-message="Password is required."
            :may-view-password="true"
        />
        <label-input
            v-else
            type="password"
            label="New password"
            name="password_new"
            v-model="person.password_new.$model"
            :validator="person.password_new"
            error-message="Password is required."
            :may-view-password="true"
        />

        <label-input
            type="password"
            label="Repeat password"
            name="password_confirm"
            :required="newPerson && !userIsAdmin"
            v-model="person.password_confirm.$model"
            :validator="person.password_confirm"
            error-message="Passwords must match."
            :may-view-password="true"
        />

        <label-input
            label="Email address"
            name="email"
            :required="true"
            v-model="person.email.$model"
            :validator="person.email"
            :error-message="emailMessage"
        />

        <label-input
            type="checkbox"
            label="Newsletter"
            v-model="person.newsletter.$model"
            :after-input="`<span style='font-size: 90%; font-style: italic;'>Check this box to subscribe to our newsletter.</span>`"
        />
        <input type="hidden" name="newsletter" :value="person.newsletter.$model ? 1 : 0">

        <template v-if="userIsAdmin">
            <label-input
                label="Is site admin"
                type="checkbox"
                v-model="person.isAdmin.$model"
            />
            <input type="hidden" name="isAdmin" :value="person.isAdmin.$model ? 1 : 0">
            <label-input
                label="Account activated"
                type="checkbox"
                v-model="person.activated.$model"
            />
            <input type="hidden" name="activated" :value="person.activated.$model ? 1 : 0">
            <label-input
                label="Marked deleted"
                type="checkbox"
                v-model="person.deleted.$model"
            />
            <input type="hidden" name="deleted" :value="person.deleted.$model ? 1 : 0">
<!--
            <label-input
                v-if="person.student"
                label="Member through"
                type="date"
                v-model="person.member_through"
            />
-->
        </template>
    </fieldset>
</template>

<script>
import LabelInput from '../../_components/form/LabelInput';

export default {
    components: {
        LabelInput,
    },

    props: {
        person: {
            type: Object,
        },
        userIsAdmin: {
            type: Boolean,
        },
        newPerson: {
            type: Boolean,
        },
    },

    data() {
        return {
            
        };
    },

    computed: {
        usernameMessage() {
            if (!this.person.username.required) {
                return 'Username is required.';
            }
            if (!this.person.username.usernameIsValid) {
                return 'Username may only contain letters, digits, dashes, and underscores, and must start with a letter or digit.';
            }
            if (!this.person.username.$pending && !this.person.username.usernameIsUnique) {
                return 'Username is already in use.';
            }
            return null;
        },

        emailMessage() {
            if (!this.person.email.required) {
                return 'Email address is required.';
            }
            if (!this.person.email.email) {
                return 'Email address is not valid.';
            }
            if (!this.person.email.$pending && !this.person.email.emailIsUnique) {
                return 'Email address is already in use. If you already have an ASC account, click LOGIN in the upper right.';
            }
            return null;
        },
    },
}
</script>

<style lang="scss">
.person-fields {
    .decoy {
        position: absolute;
        top: -100px;
    }
}
</style>
